<ion-fab vertical="bottom" horizontal="end" slot="fixed" name="addTeam">
    <ion-fab-button color="primary" (click)="createTeam()">
        <ion-icon name="add"></ion-icon>
    </ion-fab-button>
</ion-fab>